import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const CopilotLogo = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M8.62543 3.93395C8.61621 3.92936 4.42115 6.3256 4.42115 6.3256V14.1708L9.29157 16.9412L15.5842 13.3606V15.4217C15.5842 15.4217 11.5735 17.6848 9.76639 18.7085C9.41143 18.9082 9.25238 19 9.25238 19L2.4043 15.0912V5.28356L6.70077 2.83911C6.69847 2.83682 8.61621 3.92936 8.62543 3.93395Z"
      fill="#272829"
    />
    <path
      d="M13.6456 10.8863C13.6456 9.97969 13.6432 9.19471 13.6456 8.40743C13.6479 7.79001 13.6456 6.10758 13.6456 6.10758L6.75593 2.18728L1.83477 4.9875V12.0064L0 10.9621V3.9225L6.82969 0.0366211L15.5817 5.01733V9.78459L13.6456 10.8863Z"
      fill="#272829"
    />
    <path
      d="M4.99756 11.6437L9.24102 14.0583L16.1606 10.1219V4.60881C16.1606 4.60881 16.0084 4.5193 15.6512 4.31961C13.9086 3.34414 10.0846 1.15909 9.87258 1.03285C10.4488 0.704634 11.6866 0 11.6866 0L17.9999 3.59203V11.2856L9.28712 16.2433L4.99756 13.8012V11.6437Z"
      fill="#272829"
    />
  </SvgIcon>
);
